export { colorScales, dialog, space, fontWeight, fontFamily as fontFamilyGlobal, lineHeight, fontSize, textDecoration, textCase, borderRadius, borderWidth, letterSpacing } from "./generated/globals";
export * as themeTokens from "./generated/themeTokens";
export * from "./generated/OctopusTheme";
export * from "./generated/lightTheme";
export * from "./generated/darkTheme";
export { text, fontFamily } from "./generated/textThemeTokens";
export * from "./generated/OctopusTextTheme";
export * from "./generated/textTheme";
